
import InputMask from "react-input-mask";

type CNPJInputProps = {
  value: string | number | readonly string[] | undefined;
  setValue: (value: string) => void;
}

const CNPJInput = (props: CNPJInputProps) => {
  const CNPJMask = "99.999.999/9999-99";
  const classCNPJ = props.value === "" ? "input100" : "input100 has-val";
  return (
    <InputMask
      maskPlaceholder={null}
      mask={CNPJMask}
      required
      value={props.value}
      onChange={(e) => props.setValue(e.currentTarget.value)}
    >
      {() => <input type="text" className={classCNPJ} name="CNPJ" id="produto-1-cnpj" placeholder=" "/>}
    </InputMask>
  );
};

export default CNPJInput;
